export var FormHideShowBehavior;
(function (FormHideShowBehavior) {
    FormHideShowBehavior[FormHideShowBehavior["HideIfTrue"] = 0] = "HideIfTrue";
    FormHideShowBehavior[FormHideShowBehavior["HideIfFalse"] = 1] = "HideIfFalse";
})(FormHideShowBehavior || (FormHideShowBehavior = {}));
;
